import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, EyeOff } from 'lucide-react';
import api from '../api/api';

export default function NewPassword() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [tempUser, setTempUser] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('tempUser'));

    if (user) {
      setTempUser(user);
    } else {
      navigate('/');
    }
  }, [navigate]);

  if (!tempUser) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!password) {
      return setError('Please enter a password.');
    }

    const passwordRegex = /^(?=.*\d).{5,}$/;
    if (!passwordRegex.test(password)) {
      return setError(
        'Password must be at least 5 characters long and contain at least one number.'
      );
    }

    try {
      setLoading(true);

      const res = await api.PasswordLoginApi(
        tempUser.Vcode,
        password,
        tempUser.Vid
      );

      const passwordData =
        res?.PasswordLoginApijs?.Table?.[0] ||
        res?.PasswordLoginApijs?.Table1?.[0] ||
        null;

      const isSuccess =
        passwordData?.Success === 1 ||
        String(passwordData?.Success).toLowerCase() === 'success' ||
        String(passwordData?.Message || '').toLowerCase().includes('success');

      if (isSuccess) {
        localStorage.setItem('tempUser', JSON.stringify(tempUser));
        localStorage.setItem('nextPage', 'PASSWORD');
        sessionStorage.removeItem('sessionExpiredMessage');

        setMessage('Password updated successfully. Please login.');

        setTimeout(() => {
          navigate('/password');
        }, 1000);
      } else {
        setError(passwordData?.Message || 'Password update failed.');
      }
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center p-4 min-h-[80vh] relative w-full max-w-3xl mx-auto">
      <button
        onClick={() => navigate('/otpverify')}
        className="absolute flex items-center gap-2 font-semibold text-gray-600 transition top-4 left-4 hover:text-red-700"
      >
        <ArrowLeft size={20} />
        <span>Back</span>
      </button>

      <div className="w-full max-w-sm p-8 mt-10 bg-white shadow-lg rounded-2xl animate-fade-in">
        <div className="flex items-center justify-center p-4">
          <img
            src="/assets/AnnamLogo.PNG"
            alt="Logo"
            className="w-auto h-16 mx-auto"
          />
        </div>

        <div className="mb-6 text-center">
          <h1 className="text-3xl font-bold text-gray-800">Set New Password</h1>
          <p className="mt-2 text-gray-600">Enter your new password.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              className="w-full p-3 pr-10 text-center border rounded-lg"
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute text-gray-500 transform -translate-y-1/2 right-3 top-1/2"
            >
              {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
            </button>
          </div>

          {message && (
            <p className="text-sm text-center text-green-500">{message}</p>
          )}

          {error && (
            <p className="text-sm text-center text-red-500">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-bold text-white transition bg-red-500 rounded-lg hover:bg-red-600 disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
}
